import { Popover } from '@patternfly/react-core'
import { Tr, Td, Th } from '@patternfly/react-table'
import * as React from 'react'

import {
  getMedicationRouteLabelFromTypeId,
  getMedicationDosageLabelFromTypeId,
} from '@app/domain/patient-medication-history/patient-medication-history.helpers'
import type {
  MedicationDosageUnit,
  MedicationFrequencyUnit,
  MedicationRoute,
  PatientMedication,
  PatientMedicationRecord,
  PatientMedicationRecordEntry,
} from '@app/domain/patient-medication-history/patient-medication-history.interface'
import { ActionLink } from '@app/utils/styles/action-link'

import { MedicationRecordEntry } from '../medication-record-entry'

import { EditMedicationPopOverContent } from './edit-medication-popover'

interface MedicationListRowProps {
  addMedicationRecordEntry: (
    patientMedication: PatientMedication,
    medicationRecord: PatientMedicationRecord,
  ) => void
  editMedication: (
    patientMedicationId: string,
    medicationDosageUnitId: string,
    medicationRouteId: string,
    name: string,
  ) => void
  editMedicationRecordEntry: (
    patientMedication: PatientMedication,
    medicationRecord: PatientMedicationRecord,
  ) => void
  deleteMedication: (patientMedicationId: string) => void
  medicationDosageUnits: MedicationDosageUnit[]
  medicationFrequencyUnits: MedicationFrequencyUnit[]
  medicationRecord: PatientMedicationRecord[]
  medicationRoutes: MedicationRoute[]
  medicationRecordEntries: PatientMedicationRecordEntry[]
  patientMedication: PatientMedication
}

export const MedicationHistoryRow = ({
  addMedicationRecordEntry,
  editMedication,
  editMedicationRecordEntry,
  deleteMedication,
  medicationDosageUnits,
  medicationRecord,
  medicationRoutes,
  medicationFrequencyUnits,
  medicationRecordEntries,
  patientMedication,
}: MedicationListRowProps) => {
  return (
    <Tr>
      <Th isStickyColumn modifier="wrap" width={10}>
        <Popover
          aria-label="Edit Medication"
          showClose={false}
          hasAutoWidth
          zIndex={10000}
          bodyContent={() => (
            <div>
              <EditMedicationPopOverContent
                editMedication={editMedication}
                deleteMedication={deleteMedication}
                patientMedication={patientMedication}
                medicationRoutes={medicationRoutes}
                medicationDosageUnits={medicationDosageUnits}
              />
            </div>
          )}
          withFocusTrap={false}
        >
          <ActionLink className="Medication">
            {patientMedication.name}
          </ActionLink>
        </Popover>
        <br />
        {getMedicationRouteLabelFromTypeId(
          patientMedication.medicationRouteId,
          medicationRoutes,
        )}
        {', '}
        {getMedicationDosageLabelFromTypeId(
          patientMedication.medicationDosageUnitId,
          medicationDosageUnits,
        )}
      </Th>
      <>
        {medicationRecord.map((medicationRecord, idx) => (
          <Td
            width={10}
            modifier="nowrap"
            key={idx}
            style={{ textAlign: 'center', verticalAlign: 'middle' }}
          >
            <MedicationRecordEntry
              addMedicationRecordEntry={addMedicationRecordEntry}
              editMedicationEntry={editMedicationRecordEntry}
              medicationDosageUnits={medicationDosageUnits}
              medicationFrequencyUnits={medicationFrequencyUnits}
              medicationRecord={medicationRecord}
              medicationRecordEntries={medicationRecordEntries}
              patientMedication={patientMedication}
            />
          </Td>
        ))}
      </>
      <Td width={10} modifier="nowrap" />
    </Tr>
  )
}
